import React from 'react';
import CountUpText from './CountUpText';

const clamp = (val, min, max) => Math.max(min, Math.min(max, val));

const GoalStep = ({ values, onChange, onSave, onNext, saving, track }) => {
  const { goal_type, goal_lump_sum, annual_income, withdrawal_rate } = values;

  const handleRate = (e) => {
    const v = parseFloat(e.target.value || 0);
    onChange({ withdrawal_rate: clamp(v, 0.03, 0.06) });
    if (track) track('readiness_withdrawal_rate_changed', { rate: clamp(v, 0.03, 0.06) });
  };

  const handleNext = async () => {
    if (track) {
      track('readiness_goal_type_selected', { type: goal_type });
    }
    await onSave({});
    onNext();
  };

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-succession-text-secondary mt-1">This helps us estimate your Wealth Gap. You can change this later.</p>
        </div>
      </div>

      <div className="flex items-center space-x-6 text-succession-text-secondary">
        <label>
          <input className="mr-2" type="radio" name="goal_type" value="lump_sum" aria-label="Lump Sum Target" checked={goal_type === 'lump_sum'} onChange={() => onChange({ goal_type: 'lump_sum' })} />
          <span>Lump Sum Target</span>
        </label>
        <label>
          <input className="mr-2" type="radio" name="goal_type" value="income" aria-label="Annual Income Target" checked={goal_type === 'income'} onChange={() => onChange({ goal_type: 'income' })} />
          <span>Annual Income Target (pre-tax)</span>
        </label>
      </div>

      {goal_type === 'lump_sum' ? (
        <div className="space-y-3">
          <label className="block text-sm text-succession-text-secondary">Lump Sum Target</label>
          <div className="flex items-center space-x-3">
            <input type="number" min="0" step="1" inputMode="decimal" aria-describedby="lump_sum_help" className="flex-1 border border-succession-border rounded p-3" value={goal_lump_sum} onChange={(e) => onChange({ goal_lump_sum: Math.max(0, parseFloat(e.target.value || 0)) })} />
            <div className="text-lg font-semibold text-succession-text-primary whitespace-nowrap">
              <CountUpText end={goal_lump_sum || 0} formatter={(v)=>new Intl.NumberFormat(undefined,{style:'currency',currency:'USD',maximumFractionDigits:0}).format(v)} />
            </div>
          </div>
          <p id="lump_sum_help" className="text-xs text-succession-text-secondary">Enter a non-negative amount.</p>
        </div>
      ) : (
        <>
          <div className="space-y-3">
            <label className="block text-sm text-succession-text-secondary">Annual Income Target (pre-tax)</label>
            <div className="flex items-center space-x-3">
              <input type="number" min="0" step="1" inputMode="decimal" aria-describedby="annual_income_help" className="flex-1 border border-succession-border rounded p-3" value={annual_income} onChange={(e) => onChange({ annual_income: Math.max(0, parseFloat(e.target.value || 0)) })} />
              <div className="text-lg font-semibold text-succession-text-primary whitespace-nowrap">
                = <CountUpText end={annual_income > 0 ? annual_income / (withdrawal_rate || 0.04) : 0} formatter={(v)=>new Intl.NumberFormat(undefined,{style:'currency',currency:'USD',maximumFractionDigits:0}).format(v)} />
              </div>
            </div>
            <p id="annual_income_help" className="text-xs text-succession-text-secondary">We’ll convert this into a lump sum using your SWR.</p>
          </div>
          <div>
            <label className="block text-sm mb-2 text-succession-text-secondary">Safe Withdrawal Rate (3% - 6%)</label>
            <div className="flex items-center space-x-3">
              <input type="range" min="0.03" max="0.06" step="0.01" className="flex-1" value={withdrawal_rate} onChange={handleRate} aria-label="Safe withdrawal rate slider" />
              <div className="w-16 text-right text-succession-text-primary font-medium">{Math.round(withdrawal_rate * 100)}%</div>
            </div>
            <p id="swr_help" className="text-xs text-succession-text-secondary mt-1">Drag to adjust between 3% and 6%.</p>
          </div>
        </>
      )}

      <div className="flex justify-between">
        <a href="/succession/readiness/owner-diagnostic" className="px-4 py-2 rounded border border-succession-border hover:border-succession-primary" aria-label="Back">Back</a>
        <button type="button" className="bg-succession-primary text-white px-4 py-2 rounded hover:bg-succession-primary/90" onClick={handleNext} disabled={saving} aria-label="Next">Next</button>
      </div>
    </div>
  );
};

export default GoalStep;


